<script setup>
import {
  ChevronRight,
  Clock,
  CheckCircle,
  RefreshCcw,
  BanIcon,
} from "lucide-vue-next";

const props = defineProps({
  activities: { type: Array },
});

const RecentActivity = ({ activities }) => {
  const getActivityColor = (type) => {
    const colors = {
      member: "bg-blue-100 text-blue-600",
      payment: "bg-green-100 text-green-600",
      donation: "bg-purple-100 text-purple-600",
      card: "bg-orange-100 text-orange-600",
      notification: "bg-gray-100 text-gray-600",
    };
    return colors[type] || colors.notification;
  };
};
</script>

<template>
  <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
    <div class="flex items-center justify-between mb-6">
      <h3 class="text-lg font-semibold text-gray-900">Actividades Recente</h3>
      <button
        class="text-sm text-green-600 hover:text-green-700 font-medium flex items-center gap-1"
      >
        Ver todas
        <ChevronRight class="w-5 h-5" />
      </button>
    </div>

    <div class="space-y-4">
      <!-- // const Icon = activity.icon; -->
      <template v-for="(act, index) in props.activities" :key="index">
        <div
          class="flex items-start gap-3 pb-4 border-b border-gray-100 last:border-b-0 last:pb-0"
        >
          <div
            class="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
          >
            <Icon class="w-5 h-5" />
          </div>

          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium text-gray-900 mb-1">
              {{ act.title }}
            </p>
            <p class="text-sm text-gray-600 mb-2">{{ act.description }}</p>
            <div class="flex items-center gap-1 text-xs text-gray-500">
              <Clock class="w-5 h-5" />
              <span>{{ act.time }}</span>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="mt-6 pt-4 border-t border-gray-200">
      <button
        class="w-full text-center text-sm text-gray-600 hover:text-gray-800 font-medium"
      >
        Carregar mais atividades
      </button>
    </div>
  </div>
</template>
 